




























































































import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
} from "@vue/composition-api";
import { useClevertapStore } from "~/stores/clevertap";
import { decodeUid } from "~/helpers";
import { getBgColorByVariants } from "~/modules/catalog/category/helpers";
import { useConfigStore } from "~/stores/extensionApi";
import { MapProductVariant } from "~/modules/catalog/category/composables/useElasticSearch/types";

export default defineComponent({
  name: "ProductAvaiableOptions",
  props: {
    availableOptions: {
      type: Object as PropType<{ size: any[]; color: any[] }>,
      default: null,
    },
    selectedOption: {
      type: Object as PropType<{ size: any; color: any }>,
      required: true,
    },
    dataCheckOptionInstock: {
      type: Array as PropType<any[]>,
      required: true,
    },
    parentSku: {
      type: String as PropType<string>,
      default: "",
    },
    showColorAlert: {
      type: Boolean,
      default: false,
    },
    showSizeAlert: {
      type: Boolean,
      default: false,
    },
    variants: {
      type: Array as PropType<MapProductVariant[]>,
      default: () => [],
    },
    productPrice: {
      type: Number,
      default: 0,
    },
    productSpecialPrice: {
      type: Number,
      default: 0,
    },
    sizeGuideId: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const clevertapStore = useClevertapStore();
    const productData = ref(null);
    // Track last selection to avoid duplicate events
    const lastSelectedSize = ref(null);

    const configStore = useConfigStore();
    const configs = computed(() => configStore.getConfigs);
    const dataSize = configs.value?.sizeguide_config?.find(
      (e) => e.id.toString() === props.sizeGuideId
    )?.data;

    // Watch for parent product data changes
    watch(
      () => props.parentSku,
      (newSku) => {
        // Reset tracking on product change
        lastSelectedSize.value = null;
      }
    );

    const handleChangeOption = (option) => {
      // Don't allow selecting disabled color options
      // if (option.type === "color" && !isColorAvailable(option)) return;
      // Don't process disabled options
      if (option.type === "size" && !isCheckDisableSize(option.label)) {
        return;
      }

      // Update the selected option
      emit("update:selectedOption", option);

      // Track item view started in two cases:
      // 1. When selecting a size option with color already selected
      if (
        option.type === "size" &&
        props.selectedOption.color &&
        (!lastSelectedSize.value || lastSelectedSize.value !== option.uid)
      ) {
        lastSelectedSize.value = option.uid;
        trackItemViewStarted(option);
      }
      // 2. When selecting a color option for a product without size options
      else if (
        option.type === "color" &&
        (!props.availableOptions.size ||
          props.availableOptions.size.length === 0)
      ) {
        trackItemViewStarted(option);
      }
    };

    const trackItemViewStarted = (option) => {
      if (option.type === "size" && !props.selectedOption.color) return;

      try {
        let itemId;
        if (option.type === "size") {
          itemId = `${props.parentSku}-${props.selectedOption.color.label}-${option.label}`;
        } else if (
          option.type === "color" &&
          (!props.availableOptions.size ||
            props.availableOptions.size.length === 0)
        ) {
          itemId = `${props.parentSku}-${option.label}`;
        } else {
          return;
        }

        const origin =
          typeof window !== "undefined" ? window.location.origin : "";

        emit("getProductData", (product) => {
          if (!product) return;

          const categoriesArray = product.categories || [];
          const primaryCategory =
            categoriesArray.length > 0
              ? categoriesArray[categoriesArray.length - 1]
              : null;

          const categoryData = {};
          if (primaryCategory) {
            categoryData[`category_id_level_${primaryCategory.level || 1}`] =
              decodeUid(primaryCategory.uid);
            categoryData[`category_name_level_${primaryCategory.level || 1}`] =
              primaryCategory.name;
          }

          let regularPrice = props.productPrice;
          let finalPrice = props.productSpecialPrice || props.productPrice;

          const lastCategory =
            product.categories && product.categories.length > 0
              ? product.categories[product.categories.length - 1]
              : null;

          const infoFromSearch = clevertapStore.getInforFromSearch;

          const trackingData = {
            product_id: props.parentSku,
            item_id: itemId,
            item_name: product.name,

            ...categoryData,

            item_price: regularPrice,
            item_discount_price: finalPrice,

            category_path: product.url_key || "",
            item_url: `${origin}/${product.url_key || ""}`,
            item_image_url: product.image?.url || "",

            variant_count: product.configurable_options?.length || 0,

            is_search_result: infoFromSearch?.is_search_result || false,
            seach_result_query: infoFromSearch?.seach_result_query || "",
            list_id:
              infoFromSearch?.list_id ||
              (lastCategory ? decodeUid(lastCategory.uid) : ""),
            list_name:
              infoFromSearch?.list_name ||
              (lastCategory ? lastCategory.name : ""),
            position: infoFromSearch?.position || -1,
          };

          if (regularPrice > 0) {
            const win = window as any;
            if (typeof win !== "undefined" && win.clevertap) {
              try {
                if (
                  typeof clevertapStore.itemViewStartedCleverTap === "function"
                ) {
                  clevertapStore.itemViewStartedCleverTap({
                    clevertap: win.clevertap,
                    data: trackingData,
                  });
                }
              } catch (error) {
                console.error("Error sending CleverTap event:", error);
              }
            } else {
              console.warn("CleverTap not available on window object");
            }
          } else {
            console.warn("Not tracking item view - invalid price data", {
              regularPrice,
              finalPrice,
            });
          }
        });
      } catch (error) {
        console.error("Error tracking item view:", error);
      }
    };

    const isOptionSelected = (attributeOption) => {
      return (
        props.selectedOption[attributeOption.type] &&
        props.selectedOption[attributeOption.type].uid === attributeOption.uid
      );
    };

    const isColorAvailable = (colorOption) => {
      if (!props.availableOptions.size) {
        return true;
      }

      if (
        !props.dataCheckOptionInstock ||
        Object.keys(props.dataCheckOptionInstock).length === 0
      ) {
        return true;
      }

      const colorLabel = colorOption.label;

      for (const sizeOption of props.availableOptions.size) {
        const sizeLabel = sizeOption.label;
        const sku = `${props.parentSku}-${colorLabel}-${sizeLabel}`;

        for (const key in props.dataCheckOptionInstock) {
          if (
            props.dataCheckOptionInstock[key].sku === sku &&
            props.dataCheckOptionInstock[key].is_in_stock
          ) {
            return true;
          }
        }
      }

      return false;
    };

    const isCheckDisableSize = (size: string) => {
      if (props.dataCheckOptionInstock?.length > 0) {
        let sku =
          props.parentSku +
          (props.selectedOption?.color?.label
            ? "-" + props.selectedOption.color.label
            : "-00000") +
          "-" +
          size;
        let stock = props.dataCheckOptionInstock.find((e) => e.sku === sku);

        if (stock) {
          return stock?.is_in_stock;
        }
      }
      return true;
    };

    const sortSizeOptionsByKey = (data) => {
      let options = data;
      let key = "label";
      let defaultSizeText = [
        "XXXS",
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL",
      ];
      let sizeText = [];
      let sizeNumber = [];

      defaultSizeText?.forEach((label, i) => {
        options?.forEach((value, j) => {
          if (label === value[key]) {
            sizeText.push(value);
          }
        });
      });
      options?.forEach((value, i) => {
        let existInDefaultSizeText = false;
        defaultSizeText?.forEach((label, j) => {
          if (value[key] === label) {
            existInDefaultSizeText = true;
          }
        });
        if (!existInDefaultSizeText) {
          sizeNumber.push(value);
        }
      });
      sizeNumber.sort((a, b) => a[key] - b[key]);
      return [...sizeNumber, ...sizeText];
    };

    const openSizeGuide = () => {
      emit("openSizeGuide");
    };

    const checkSizeByVariants = (sizeOption, colorOption) => {
      if (props.availableOptions.color.length > 0 && !colorOption) return false;
      if (!props.variants || !props.variants.length) return false;
      if (props.availableOptions.color.length == 0){
        return true;
      }

      const hasMatchingSize = props.variants.some(
        (variant) =>
          variant?.size == sizeOption?.value_index &&
          variant?.color == colorOption?.value_index
      );
      return hasMatchingSize;
    };

    return {
      isOptionSelected,
      getBgColorByVariants,
      handleChangeOption,
      isCheckDisableSize,
      sortSizeOptionsByKey,
      openSizeGuide,
      isColorAvailable,
      trackItemViewStarted,
      checkSizeByVariants,
      dataSize,
    };
  },
});
